var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3746 13.8278H23.3105L33.2597 1.25691C33.4656 0.990723 33.2798 0.604004 32.9433 0.604004H13.6827C13.542 0.604004 13.4064 0.679339 13.3361 0.804897L0.323299 23.2798C0.167607 23.546 0.358455 23.8825 0.669839 23.8825H9.42877L4.93881 41.8423C4.84339 42.234 5.31549 42.5103 5.60678 42.229L34.6509 14.5158C34.912 14.2697 34.7362 13.8278 34.3746 13.8278ZM10.7798 32.5711L13.8082 20.4673H5.9031L15.4254 4.02421H26.7056L16.2441 17.248H26.8412L10.7798 32.5711Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energy-icon.e7308f587057c01a7b1aa95802092b93.svg";
export { ForwardRef as ReactComponent };